// Data
import { fgConfig } from 'utilities/configuration';

// Utilities
import { useContext, useUser } from 'utilities/hooks';

const useConfig = ({
    initiativeType = null,
    activityType = null,
    resultType = null,
}) => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const { ROUTE } = useContext();
    const { getUserAccountType } = useUser();

    // ///////////////////
    // METHODS
    // ///////////////////

    function getActivities() {
        if (!initiativeType) {
            console.error('Config.getActivities: Initiative not set');
            return [];
        }
        return fgConfig[initiativeType]?.activities;
    }

    function getActivityTypes() {
        return Object.keys(getActivities()) || [];
    }

    function getResults() {
        if (!initiativeType) {
            console.error('Config.getResults: Initiative not set');
            return [];
        }
        return fgConfig[initiativeType]?.results;
    }

    function getResultTypes() {
        return Object.keys(getResults());
    }

    function indicatorMetricTargetOn() {
        if (!initiativeType || !activityType) {
            console.error('Config: Initiative or activity not set');
            return false;
        }
        return getActivities()?.[activityType]?.indicatorMetricTargetOn;
    }

    function getAssistedInteractionsForDropdown() {
        const interactionsForRoute =
            (fgConfig[initiativeType] || fgConfig['defaults'])
                ?.assistedInteractions?.dropdown?.routes[ROUTE] || {};

        return Object.entries(interactionsForRoute).reduce(
            (acc, [key, value]) => {
                if (value.includes(getUserAccountType())) {
                    acc.push(key);
                }
                return acc;
            },
            []
        );
    }

    function getPermissionForAssistedInteractionInputs(promptKey) {
        return (
            fgConfig[initiativeType] || fgConfig['defaults']
        )?.assistedInteractions?.inputs?.[promptKey].includes(
            getUserAccountType()
        );
    }

    // ///////////////////
    // EFFECTS
    // ///////////////////

    return {
        getActivities,
        getActivityTypes,
        getResults,
        getResultTypes,
        indicatorMetricTargetOn,
        getAssistedInteractionsForDropdown,
        getPermissionForAssistedInteractionInputs,
    };
};

export default useConfig;
